import styled from 'styled-components';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeMediaQuery, themeSpace, themeColor } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { Button } from '@components/Button';
import { TextPairing } from '@components/TextPairing';

export const SectionContainer = styled(Box)`
  width: 100%;
`;

export const DiversityText = styled(Text)<{ marginBottom?: number }>`
  max-width: 490px;
  margin-bottom: ${({ marginBottom }) => (marginBottom ? themeSpace(marginBottom) : themeSpace(6))};
`;

export const DiversityTextBox = styled(Box)`
  width: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    width: 85%;
  }
  ${themeMediaQuery('lg')} {
    width: 55%;
  }
`;

export const DiversityFlex = styled(Flex)`
  transform: translate(0px, -70px);
`;

export const DiversityLogoWrapper = styled(Flex)`
  justify-content: center;
  align-items: flex-start;
`;

export const DiversityLogoBox = styled(Box)`
  width: 15%;
  ${themeMediaQuery('below_sm')} {
    width: 30%;
  }
`;

export const DiversityJoinUsText = styled(Flex)``;

export const JoinUsImage = styled(CloudImage)`
  height: 668px;
  width: 100%;
  object-fit: cover;
  ${themeMediaQuery('below_sm')} {
    height: 368px;
  }
`;

export const ExploreTextPairing = styled(TextPairing)`
  .text-pairing-body {
    *:last-child {
      color: ${themeColor('linkDefault')};
      &:hover {
        color: ${themeColor('linkHover')};
        transition: 0.7s;
      }
    }
  }
`;

export const StyledEqualImage = styled.img`
  width: 100%;
`;

export const ReadMoreButton = styled(Button)`
  background: none;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  height: auto;
  width: auto;
  &:hover {
    background: none;
    border: none;
    outline: none;
  }
`;
